/**
 * MerelsTitle renders the app title when no game is active.
 *
 * Why: Extracting this keeps Header focused on layout. The title has
 * custom font styling that's specific to the brand.
 *
 * When to use: Rendered by Header when no game is active (gameId is null).
 */
import { headerTestIds } from './header.testIds'

export interface MerelsTitleProps {
  /** Accent color for the title */
  accentColor?: string
}

export function MerelsTitle({ accentColor }: MerelsTitleProps) {
  return (
    <h2
      className="font-semibold leading-none m-0"
      data-testid={headerTestIds.gameName}
      style={{
        color: accentColor,
        fontFamily: "'MorrisRomanBlack', serif",
        fontSize: 'var(--menu-title-size)',
        lineHeight: '1',
      }}
    >
      Merels
    </h2>
  )
}
